// extracted by mini-css-extract-plugin
export default {"wrapper":"Expander_wrapper","isExpanded":"Expander_isExpanded"};